exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prose.cloud a[data-v-e9c9d272] {\n  color: var(--cw-alt) !important;\n}\n.tag-item[data-v-e9c9d272]::after {\n  position: absolute;\n  right: -0.5rem;\n  top: 50%;\n  content: '';\n  background: currentColor;\n  height: 4px;\n  width: 2px;\n  border-radius: 6px;\n  transform: translateY(-50%);\n}\n", ""]);

// exports
